import { Box } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

type OverlayProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  children: React.ReactNode;
};

function Overlay({ open, setOpen, children }: OverlayProps) {
  return (
    <Box
      sx={(theme) => ({
        position: 'fixed',
        top: 0,
        bottom: 0,
        right: 0,
        width: 800,
        backgroundColor: theme.palette.custom.white,
        borderLeft: `1px solid ${theme.palette.custom.divider}`,
        boxShadow: `-6px 0 12px 0 ${theme.palette.custom.boxShadow}`,
        overflow: 'auto',
        zIndex: 99,
      })}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        overflow="hidden"
        height="100%"
      >
        {children}
      </Box>
    </Box>
  );
}

export default Overlay;
